var _title, _rect, _polygon, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconChurch = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "aa6c8882-aac7-40ab-8fcf-61e416164156",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icoontjes_data")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 120,
  y: 120,
  width: 784,
  height: 784,
  fill: "none"
})), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "712.65 361.2 660.05 572.4 659.55 572.4 584.75 434.7 545.55 434.7 509.95 313.7 474.35 434.7 435.15 434.7 360.65 571.8 308.05 361.2 255.35 572.4 255.35 783.5 461.88 783.5 461.88 672.63 558.82 672.63 558.82 783.5 660.05 783.5 765.35 783.5 765.35 572.4 712.65 361.2"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 461.88,
  y: 783.5,
  width: 96.94,
  height: 1.5,
  fill: "#fff"
})));
export default SvgIconChurch;